import { isPresent } from "./isPresent";

export function isArrayFilled<T>(t: T[] | undefined | null | void): t is T[] {
  return isPresent(t) && t.length > 0;
}
